export default __webpack_public_path__ + "static/media/tropic.63611f1e.jpg";